export default __webpack_public_path__ + "static/laszyk-7b7afaa8e62613fcd73cd000d1f87b41.png";